import { RootState } from "../store";

export const getTrainString = (state: RootState) => {
  return state.trainerReducer.trainString;
};

export const getCursorIndex = (state: RootState) => {
  return state.trainerReducer.cursorIndex;
};

export const getTrainStringCharStatus = (state: RootState) => {
  return state.trainerReducer.trainStringCharStatus;
};

export const getTypingSpeed = (state: RootState) => {
  return state.trainerReducer.typingSpeed;
};

export const getAccuracy = (state: RootState) => {
  return state.trainerReducer.accuracy;
};

export const getErrorRate = (state: RootState) => {
  return state.trainerReducer.errorRate;
};
